import React from "react";
import { Container } from "react-bootstrap";

function AdminFooter() {
  return (
    <>
      <footer className="footer">
        <Container fluid className="pl-4 ml-2">
          <nav>
            <ul className="footer-menu">
              <li>
                <a href="https://siami.umn.ac.id">
                  Home
                </a>
              </li>
              <li>
                <a href="https://www.umn.ac.id/en/home/">
                  Company
                </a>
              </li>
            </ul>
            <p className="copyright text-center">
              © <script>document.write(new Date().getFullYear())</script>
              <a href="https://umn.ac.id">Universitas Multimedia Nusantara</a>, Excellent career begin with excellent education.
            </p>
          </nav>
        </Container>
      </footer>
    </>
  );
}

export default AdminFooter;
